module.exports = __webpack_public_path__ + "img/exam (1).fb782f32.png";